/**
 * Jquery Editable Select wrapper.
 * used with htmlstream front theme
 *
 * @author Jai Lamerton
 * @version 1.0
 *
 */
import 'jquery-editable-select';

(function ($) {
  'use strict';

  $.HSCore.components.JqueryEditableSelect = {
    /**
     *
     *
     * @var Object _baseConfig
     */
    _baseConfig: {},

    /**
     *
     *
     * @var jQuery pageCollection
     */
    pageCollection: $(),

    /**
     * Initialization of Editable Select wrapper.
     *
     * @param String selector (optional)
     * @param Object config (optional)
     *
     * @return jQuery pageCollection - collection of initialized items.
     */

    init: function (selector, config) {
      this.collection = selector && $(selector).length ? $(selector) : $();
      if (!$(selector).length) return;

      this.config = config && $.isPlainObject(config) ?
        $.extend({}, this._baseConfig, config) : this._baseConfig;

      this.config.itemSelector = selector;

      this.initJqueryEditableSelect();

      return this.pageCollection;
    },

    initJqueryEditableSelect: function () {
      //Variables
      var $self = this,
        collection = $self.pageCollection;

      // changes default for the plugin's `effects` option to `slide`
      $.fn.editableSelect.Constructor.DEFAULTS.effects = 'slide';

      //Actions
      this.collection.each(function (i, el) {

        //Variables
        var $this = $(el),
          optFilter = $this.data('select-filter'),
          optEffect = $this.data('select-effect'),
          optDuration = $this.data('select-duration'),
          optTrigger = $this.data('select-trigger');

        // console.log($this);
        var $this = $(el).editableSelect();
        $this.editableSelect({
          filter: optFilter ? optFilter : 'true', // 'true', 'false'
          effects: optEffect ? optEffect : 'default', // 'default', 'slide', 'fade'
          duration: optDuration ? optDuration : 'fast', // 'fast', 'slow'
          trigger: optTrigger ? optTrigger : 'focus' // 'focus', 'manual'
        });

        // $this.css({
        //   width: $this.val().length * 7.5
        // });

        //Actions
        collection = collection.add($this);
      });
    }
  };
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/components/vendor/jquery-editable-select.js